<template>
  <div class="grm-loading">
    <div class="loading-container">
      <img
          class="loading-image"
          :src="require('@/assets/images/camstudy/loading_gooroomee_change_type.png')"
          alt="Loading"
      />
      <div class="loading-message" v-html="message"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GrmTransitionLoading',
  props: {
    roomLevel: {
      type: String,
      default: 'PREMIUM'
    }
  },
  data() {
    return {
      message: ''
    }
  },
  mounted() {
    if (this.roomLevel === 'FREE') {
      this.message = this.$t('camstudy.roomType.changeToFree')
    } else {
      this.message = this.$t('camstudy.roomType.change')
    }
  }
}
</script>

<style scoped>
.grm-loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  padding-left: 0;
  padding-right: 0;
}

.loading-container {
  background: white;
  padding: 40px;
  border-radius: 20px;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  width: 360px;
  height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
}

.loading-image {
  width: 150px;
  height: 150px;
  margin-bottom: 24px;
}

.loading-message {
  color: #000000;
  font-size: 18px;
  line-height: 1.5;
  text-align: center;
  word-break: keep-all;
  font-weight: 700;
}

@media (max-width: 360px) {
  .grm-loading {
    margin-left: 8px;
    margin-right: 8px;
  }

  .loading-container {
    width: 100%;
  }
}

</style>
